import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, CloseBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import { membersMng } from '../api/membersMng';
import MemberForm from './MemberForm';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

function AddMemberDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { open, onClose, onAdd = () => {} } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState();

  React.useEffect(() => {
    setFormData({
      tempPass: '0000',
    });
  }, [open]);

  const createMember = async () => {
    setLoading(true);
    const member = { ...formData.values };
    delete member.isValid;
    try {
      await membersMng.addMember(member);
      onAdd();
      _onClose();
      toast.success('Member added successfully', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error(e.reason || e.message || 'Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const _onClose = () => {
    setFormData({});
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        Add Member
        <CloseBtn
          onClick={() => {
            onClose();
          }}
        />
      </DialogTitle>
      <DialogContent>
        <MemberForm
          onChange={(data) => {
            setFormData(data);
          }}
          values={formData}
        />
        <div
          style={{
            marginBottom: '20px',
            marginTop: '10px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || !formData || !formData.isValid}
            label={<span>Add Member</span>}
            onClick={createMember}
            onEnter={createMember}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

AddMemberDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
};

AddMemberDialog.defaultProps = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: () => {},
};

export default AddMemberDialog;
